import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LojistikIrsaliye } from 'src/model/lojistik-irsaliye';
import { LojistikIrsaliyeKalem } from 'src/model/lojistik-irsaliye-kalem';
import { LojistikIrsaliyelerPage } from 'src/model/lojistik-irsaliyeler-page';
import { RestService } from 'src/providers/rest.service';

@Component({
  selector: 'app-tasimaci',
  templateUrl: './tasimaci.component.html',
  styleUrls: ['./tasimaci.component.css']
})
export class TasimaciComponent implements OnInit {

  showSearchResultCount = 10;
  showSearchResultCountModel: number[] = [10, 20, 50, 100];
  irsaliyeAraLoading = false;
  irsaliyeAraText = '';
  source: LojistikIrsaliyelerPage = null;
  source2: string[] = [];
  showSearchCurrentPage = 1;
  private subscriptions: Subscription[] = [];
  irsaliyeKalemler: LojistikIrsaliyeKalem[];
  basTar: Date = null;
  bitTar: Date = null;
  lojistikIrsaliyeList:any;


  constructor(private restService: RestService) { }

  ngOnInit() {
    this.getIrsaliyeList()
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getLojistikIrsaliyeler() {
    this.restService.getLojistikIrsaliyeler(this.showSearchCurrentPage, this.showSearchResultCount
      , this.dateToTicks(this.basTar), this.dateToTicks(this.bitTar)
      , this.irsaliyeAraText).subscribe(res => {
      this.source = res;
      this.source2.push(this.dateToTicks(this.basTar), this.dateToTicks(this.bitTar));
    });
  }

  showPreviousPageSearchResults() {
    this.showSearchCurrentPage--;
    this.getLojistikIrsaliyeler();
  }

  showNextPageSearchResults() {
    this.showSearchCurrentPage++;
    this.getLojistikIrsaliyeler();
  }

  irsaliyeAraInputChange() {
    this.showSearchCurrentPage = 1;
    this.getLojistikIrsaliyeler();
  }

  detay(event: LojistikIrsaliye) {
    if (event) {
      this.restService.getLojistikIrsaliyeKalemler(event.irsaliyeNo, event.cariKodu).subscribe(res => {
        this.irsaliyeKalemler = res;
      });
    }
    else
      this.irsaliyeKalemler = null;
  }

  tarihTemizle(x: any) {
    if (x === 1)
      this.basTar = null;
    else if (x === 2)
      this.bitTar = null;
  }

  getirButonDisabled(): boolean {
    if (this.basTar === null || this.bitTar === null)
      return true;

    return false;
  }

  dateToTicks(date: Date) : string{
    if (date !== null)
      return date.toLocaleDateString();

    return null;
  }


  getIrsaliyeList = async () =>{
    let activeUser = JSON.parse(localStorage.getItem('user'));
    this.restService.tasimaciGetLojistikIrsaliyeListByVkn(activeUser.vkn).subscribe(res => {
      this.lojistikIrsaliyeList = {};
      this.lojistikIrsaliyeList.lojistikIrsaliyeList = res;
      this.lojistikIrsaliyeList.permission = false;
    })
  }
}
